import { createSlice } from '@reduxjs/toolkit';
import { eventInit, venueInit } from 'types/event';
import { CurrentEvent } from 'types/currentEvent';

// initial state
const initialState: CurrentEvent = {
  mainData: eventInit,
  venue: venueInit,
  services: [],
  gigs: [],
  deposits: [],
  expenses: [],
  histories: [],
  clients: [],
  segments: [],
  editLocks: {
    details: null
  },
  loadedEventId: null
};

// ==============================|| SLICE - ALGOLIA ||============================== //

const currentEvent = createSlice({
  name: 'currentEvent',
  initialState,
  reducers: {
    setEventMainData(state, action) {
      state.mainData = action.payload;
    },
    setVenue(state, action) {
      state.venue = action.payload;
    },
    setClients(state, action) {
      state.clients = action.payload;
    },
    setServices(state, action) {
      state.services = action.payload;
    },
    setGigs(state, action) {
      state.gigs = action.payload;
    },
    setDeposits(state, action) {
      state.deposits = action.payload;
    },
    setExpenses(state, action) {
      state.expenses = action.payload;
    },
    setSegments(state, action) {
      state.segments = action.payload;
    },
    setHistories(state, action) {
      state.histories = action.payload;
    },
    setEditLocks(state, action) {
      state.editLocks = {
        ...state.editLocks,
        ...action.payload
      };
    },
    setLoadedEventId(state, action: { payload: string | null }) {
      state.loadedEventId = action.payload;
    },
    clearCurrentEvent(state) {
      return initialState;
    }
  }
});

export default currentEvent.reducer;

export const {
  setEventMainData,
  setVenue,
  setServices,
  setGigs,
  setDeposits,
  setExpenses,
  setSegments,
  setHistories,
  setClients,
  setEditLocks,
  setLoadedEventId,
  clearCurrentEvent
} = currentEvent.actions;
